import React, { useState, useEffect } from "react";
import { useStore } from "react-redux";
import { EditForm } from "../../Redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import { GET_CUSTOMER_DASHBOARD_REQUEST } from "../../Redux/Constants";
import { useHistory } from "react-router";

import "./Forms.css";

function ProfileEditForm({ close, userDetail }) {
  console.log("userDetails", userDetail);
  const history = useHistory();

  const [fullname, setName] = useState(userDetail ? userDetail.fullname : "");
  const [age, setAge] = useState(userDetail ? userDetail.age : "");
  const [email, setEmail] = useState(userDetail ? userDetail.email : "");
  const [address, setAddress] = useState(userDetail ? userDetail.address : "");
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const [nameError, setNameError] = useState();
  //VALLIDATION for email
  const emailValidation = (e) => {
    setEmail(e.target.value);

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email.match(regex)) {
      setError(false);
    } else {
      console.log("invalid email");
      setError(true);
    }
    // ;
  };
 

  //HANDEL USERNAME FUNCTON BELOW THIS COMMENT
  const handelUserName = (e) => {
    setNameError("");
    setName(e.target.value);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
   
    if (!e.target.value.match(characterRegex)) {
      setNameError("Invalid Name");
      console.log("invalid name")
    }
    if (e.target.value == "") {
      setNameError("");
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const datakey = JSON.parse(localStorage.getItem("user"));
    console.log("token from edit form", datakey);
    const token = datakey.token;
    const phonenumber = datakey.username;
    console.log("token", token);
    // const config = {
    //     headers: {
    //       Authorization: `Token ${token}`,
    //     },
    //   };
    const body = {
      fullname,
      age,
      email,
      address,
    };
    console.log("form submitted", body);

    dispatch(EditForm(token, body, phonenumber));
    dispatch({
      type: GET_CUSTOMER_DASHBOARD_REQUEST,
    });
    close();
  };

  const handelAge = (e) => {
    setAge(e.target.value);
    console.log(age);
  };
  const handleNameChange = (e) => {
    // const regex = /\d/;
    const regex = /^[a-zA-Z\s]+$/g;
    console.log(regex.test(e.target.value));

    if (regex.test(e.target.value)) {
      // console.log("value is true")

      setButtonDisable(true);
      // setValue("#"+validator.trim(e.target.value)+"#")
      setMessageName("Please Enter Character Only");
    } else if (!regex.test(e.target.value)) {
      // console.log("value ifs false")
      if (e.target.value !== "") {
        setButtonDisable(false);
        setMessageName("Enter Character only");
      } else {
        setMessageName("");
      }
    } else {
      setButtonDisable(false);
      setMessageName("");
    }

    setName(e.target.value);
  };

  return (
    <div className="EditFormDiv">
      <form onSubmit={handleSubmit} className="editForm">
        <h1>Edit Form</h1>
        <input
          placeholder="Name"
          value={fullname}
          required
          onChange={handelUserName}
        ></input>
 <span className={nameError ? "error" : "errorDivEdit" }>{nameError ? nameError : null}</span>
        <br></br>
        {/* <span className={nameError ? "error" : "errorDivEdit" }>{nameError ? nameError : null}</span><br /> */}
        <input
          placeholder="Age"
          required
          type="number"
          value={age}
          onChange={handelAge}
        ></input>
        <br></br>
        <input
          type="email"
          placeholder="Email"
          required
          value={email}
          onChange={emailValidation}
        ></input>
        <br></br>
        <input
          value={address}
          placeholder="Address"
          onChange={(e) => setAddress(e.target.value)}
        ></input>
        <br></br>
        <span className="error">{error ? "Invalid Email" : null}</span>
        <br />
        <button
          className={error || nameError ? "disableButton" : null}
          disabled={error || nameError ? "disabled" : null}
          type="submit"
        >
          Submit
        </button>
      </form>
    </div>
  );
}

export default ProfileEditForm;
